export const getCssVariable = variable => {
  return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
};

export const isLightColor = color => {
  // Remove # if present
  color = color.replace('#', '');
  // Convert to RGB
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5;
};
